import Vue from "vue";

type BooleanItem = { value: boolean; text: string };

export default (i18nKey: string) =>
    Vue.extend({
        props: {
            value: {
                type: Boolean,
                default: null
            }
        },
        render(createElement) {
            const items = (this.$t(i18nKey) as unknown) as BooleanItem[];
            const match = Array.isArray(items) ? items.find(item => item.value === this.value) : undefined;

            return createElement("span", match ? match.text : "-");
        }
    });
